import {useBarcode} from 'react-barcodes';

export const Barcode = ({ value, ...options }) => {
  const { inputRef } = useBarcode({ value,
    options: {
      font: 'Roboto Mono',
      fontSize: 14,
      ...options,
    }});

  return <svg ref={inputRef}/>;
};
